import orderBy from 'lodash-es/orderBy';
import {
  getB2xPermissionRoles,
  getUserList,
  GET_USER_LIST_URL,
} from 'src/clients';
import { GET_B2X_PERMISSION_ROLES_URL, UserRoles } from 'src/constants';
import { useAppSelector } from 'src/hooks';
import useSWR from 'swr';

export const useB2xUserRoles = () => {
  const { data: roles = [], ...rest } = useSWR(
    GET_B2X_PERMISSION_ROLES_URL,
    () => getB2xPermissionRoles().then(res => res.data.data ?? []),
  );

  const data = orderBy(
    roles.filter(role => role.role !== UserRoles.SuperAdmin),
    'role',
    'asc',
  );

  return { data, ...rest };
};

export const useUserManagementList = () => {
  const companyId = useAppSelector(state => state.auth.user?.company_id ?? '');
  const { data, ...rest } = useSWR([GET_USER_LIST_URL, companyId], () =>
    getUserList(companyId).then(res => res.data.data ?? []),
  );
  return { data: data || [], ...rest };
};
